export const STATIC_COL_WIDTH = 306;
